import { render, staticRenderFns } from "./WorkPermitInfoModal.vue?vue&type=template&id=6aa26d0e&scoped=true"
import script from "./WorkPermitInfoModal.vue?vue&type=script&lang=js"
export * from "./WorkPermitInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa26d0e",
  null
  
)

export default component.exports